<template>
  <b-row>
    <b-col>
      <h6>{{ $t('views.excmdevice.show.clientSection.deviceAgreement.title') }}:</h6>
      <b-row v-for="(deviceAgreement, index) in deviceAgreements" v-bind:key="'deviceAgreement-' + index">
        <b-col>
          <b-row>
            <b-col cols="1">
              <h6>#{{ index + 1 }}</h6>
            </b-col>
            <b-col>
              <b-row>
                <b-col>
                  <p><b>{{ $t('views.excmdevice.show.clientSection.deviceAgreement.number') }}:</b> {{ deviceAgreement.agreement.agreementNumber }}</p>
                  <p><b>{{ $t('views.excmdevice.show.clientSection.deviceAgreement.dateFrom') }}:</b> {{ deviceAgreement.agreement.dateFrom }}</p>
                  <p><b>{{ $t('views.excmdevice.show.clientSection.deviceAgreement.dateTo') }}:</b> {{ deviceAgreement.agreement.dateTo }}</p>
                </b-col>
              </b-row>
              <b-row v-if="ableToShowAgreement">
                <b-col>
                  <b-btn class="btn btn-success float-right" :to="{ name: 'EXCMAgreementShow', params: { id: deviceAgreement.agreement['@id'] }}" size="sm">{{ $t('views.excmdevice.show.clientSection.deviceAgreement.moveToAgreement') }}</b-btn>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <hr>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div v-if="view">
            <button
                    :disabled="!view['hydra:previous']"
                    type="button"
                    class="btn btn-basic btn-sm"
                    @click="getDeviceAgreements(view['hydra:first'])">{{$t('buttons.firstPage')}}</button>
            &nbsp;
            <button
                    :disabled="!view['hydra:previous']"
                    type="button"
                    class="btn btn-basic btn-sm"
                    @click="getDeviceAgreements(view['hydra:previous'])">{{$t('buttons.previousPage')}}</button>
            &nbsp;
            <button
                    :disabled="!view['hydra:next']"
                    type="button"
                    class="btn btn-basic btn-sm"
                    @click="getDeviceAgreements(view['hydra:next']+'title=tytuł')">{{$t('buttons.nextPage')}}</button>
            &nbsp;
            <button
                    :disabled="!view['hydra:last']"
                    type="button"
                    class="btn btn-basic btn-sm"
                    @click="getDeviceAgreements(view['hydra:last'])">{{$t('buttons.lastPage')}}</button>
            &nbsp;
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <button type="button"
                  class="mb-1 mr-1 btn btn-info btn-circle btn-sm fa fa-plus fa-lg"
                  v-b-tooltip.hover :title="$t('buttons.addAgreementDevice')"
                  @click="addDevicePeripheralDevice()">
          </button>
          <span class="h6">{{$t('views.excmdevice.show.clientSection.peripheralDevice')}}: </span>
        </b-col>
      </b-row>
      <b-row v-if="item.devicePeripheralDevices.length < 1">
        <b-col>{{$t('views.excmdevice.show.clientSection.noPeripheralDevices')}}</b-col>
      </b-row>
      <b-row v-for="(peripheralDevice, index) in item.devicePeripheralDevices" v-bind:key="'peripheralDevice-' + index">
        <b-col>
          <b-row v-if="index !== 0">
            <b-col>
              <hr class="mt-2 mb-2">
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="float-left">
                <h5>#{{index + 1}}</h5>
              </div>
              <div class="float-left ml-3">
                <p class="m-0">
                  <b>{{ peripheralDevice.peripheralDevice.title }}</b><br>
                </p>
                <b-row>
                  <b-col>
                    <b-button class="btn btn-success" size="sm" @click="updateDevicePeripheralDevice(peripheralDevice)">{{$t('buttons.edit')}}</b-button>
                    <b-button class="btn btn-danger" size="sm" @click="deleteItem(peripheralDevice)">{{$t('buttons.delete')}}</b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr class="mb-1 mt-1">
      <b-row>
        <b-col>
          <h6>{{$t('menu.cases.index')}}: </h6>
          <div v-if="item.cases && item.cases.length < 1" > {{ $t('views.excmcase.list.noCases') }} </div>
          <table v-else class="table table-sm table-grid">
            <thead>
            <tr>
              <th></th>
              <th>{{ $t('views.excmcase.show.created') }}</th>
              <th>{{ $t('views.excmcase.form.caseType') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in item.cases" :key="item['@id']">
              <th>
                <i v-b-tooltip.hover :title="item.status.title"
                   class="fa fa-circle fa-lg mr-2"
                   :style="'color: ' + item.status.color">
                </i>
              </th>
              <td>
                {{ $moment(item.createdAt).format('YYYY-MM-DD') }}
              </td>
              <td>
                <router-link v-if="item.canViewDetails"
                  :to="{ name: 'EXCMCaseShow', params: {id: item['@id']} }"
                >{{item.caseType.title}}</router-link>
                <span v-else>{{item.caseType.title}}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <hr>
        </b-col>
      </b-row>
    </b-col>
    <CreateDevicePeripheralDeviceModal></CreateDevicePeripheralDeviceModal>
    <UpdateDevicePeripheralDeviceModal></UpdateDevicePeripheralDeviceModal>
  </b-row>
</template>

<script>
import { checkPermission } from '@/utils/checkRoles.js'
import getId from '@/utils/getIdFromLink'
import CreateDevicePeripheralDeviceModal from '@/components/Dashboard/Views/excmdeviceperipheraldevice/components/CreateDevicePeripheralDeviceModal'
import UpdateDevicePeripheralDeviceModal from '@/components/Dashboard/Views/excmdeviceperipheraldevice/components/UpdateDevicePeripheralDeviceModal'
import { mapActions } from 'vuex'

export default {
  name: 'ClientSecton',
  components: { UpdateDevicePeripheralDeviceModal, CreateDevicePeripheralDeviceModal },
  props: {
    item: {
      type: Object,
      required: true
    },
    retrieve: {
      type: Function,
      required: false
    }
  },

  data () {
    return {
      view: null,
      deviceAgreements: [],
      totalDeviceAgreementsNumber: 0
    }
  },

  computed: {
    ableToShowAgreement () {
      return this.checkRoles('agreements', 'EXCMAgreementShow')
    }
  },

  created () {
    this.getDeviceAgreements('api/e_x_c_m_devices/' + this.getIdLink(this.item['@id']) + '/device_agreements?_page=1')
  },

  methods: {
    ...mapActions({
      del: 'excmdeviceperipheraldevice/del/del'
    }),
    getDeviceAgreements (url) {
      this.$http
        .get(url)
        .then(response => {
          this.$emit('input', response.data['hydra:totalItems'])
          this.view = response.data['hydra:view']
          this.deviceAgreements = response.data['hydra:member']
          for (let i in this.deviceAgreements) {
            this.deviceAgreements[i].agreement.dateFrom = this.$moment(this.deviceAgreements[i].agreement.dateFrom).format('YYYY-MM-DD')
            this.deviceAgreements[i].agreement.dateTo = this.$moment(this.deviceAgreements[i].agreement.dateTo).format('YYYY-MM-DD')
          }
          this.totalDeviceAgreementsNumber = response.data['hydra:totalItems']
        })
        .catch(error => {
          this.isLoading = false
          console.log(error)
          this.error = error
        })
    },
    addDevicePeripheralDevice () {
      this.$store.state.modals.excmdeviceperipheraldevice.create.show = 1
      this.$store.state.modals.excmdeviceperipheraldevice.create.deviceIRI = this.item['@id']
    },
    updateDevicePeripheralDevice (devicePivot) {
      this.$store.state.modals.excmdeviceperipheraldevice.update.devicePivot = devicePivot
      this.$store.state.modals.excmdeviceperipheraldevice.update.show = 1
    },
    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.del(item).then(() => this.retrieve(decodeURIComponent(this.$route.params.id)))
        this.$Swal({
          title: this.$t('notifications.deletedTitle'),
          type: 'success'
        })
      })
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
